import { create } from 'zustand';

export const useRuntimeThemeStore = create((set) => ({
  primaryColor: '',
  secondaryColor: '',
  backgroundColor: '',
  textColor: '',
  banners: [],
  subBanners: [],
  subPromotionBanners: [],
  promotionBanners: [],
  appBanners: [],
  appSubBanners: [],
  appPromotionBanners: [],
  appSubPromotionBanners: [],
  enableHeroBanners: true,
  enableSubBanners: true,
  enablePromotionBanners: true,
  enableSubPromotionBanners: true,
  ecommerceSettings: null,
  features: [],
  setThemeColors: ({
    primaryColor,
    secondaryColor,
    backgroundColor,
    textColor,
    banners,
    subBanners,
    subPromotionBanners,
    promotionBanners,
    appBanners,
    appSubBanners,
    appPromotionBanners,
    appSubPromotionBanners,
    enableHeroBanners,
    enableSubBanners,
    enablePromotionBanners,
    enableSubPromotionBanners,
    ecommerceSettings,
    features,
  } = {}) =>
    set({
      primaryColor: primaryColor || '',
      secondaryColor: secondaryColor || '',
      backgroundColor: backgroundColor || '',
      textColor: textColor || '',
      banners: Array.isArray(banners) ? banners : [],
      subBanners: Array.isArray(subBanners) ? subBanners : [],
      subPromotionBanners: Array.isArray(subPromotionBanners) ? subPromotionBanners : [],
      promotionBanners: Array.isArray(promotionBanners) ? promotionBanners : [],
      appBanners: Array.isArray(appBanners) ? appBanners : [],
      appSubBanners: Array.isArray(appSubBanners) ? appSubBanners : [],
      appPromotionBanners: Array.isArray(appPromotionBanners) ? appPromotionBanners : [],
      appSubPromotionBanners: Array.isArray(appSubPromotionBanners) ? appSubPromotionBanners : [],
      enableHeroBanners: enableHeroBanners ?? true,
      enableSubBanners: enableSubBanners ?? true,
      enablePromotionBanners: enablePromotionBanners ?? true,
      enableSubPromotionBanners: enableSubPromotionBanners ?? true,
      ecommerceSettings: ecommerceSettings || null,
      features: Array.isArray(features) ? features : [],
    }),
}));
